import { render } from "./BlogListView.vue?vue&type=template&id=b1543cc0"
import script from "./BlogListView.vue?vue&type=script&lang=js"
export * from "./BlogListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__